module.exports = __webpack_public_path__ + "img/bera.a8f00a59.png";